import { Input } from "@mui/material";
import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { SEARCH_DEBOUNCE_DELAY } from "../../../utils/constant";

export default function DebounceInput({ handleDebounce = () => {}, debounceTimeout = SEARCH_DEBOUNCE_DELAY, ...rest }) {
  const timerRef = useRef();

  const handleChange = event => {
    // Clear any existing timer to reset the countdown
    clearTimeout(timerRef.current);
    
    // Set a new timer
    timerRef.current = setTimeout(() => {
      handleDebounce(event.target.value);
    }, debounceTimeout);
  };

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return <Input {...rest} onChange={handleChange} />;
}

DebounceInput.propTypes = {
  handleDebounce: PropTypes.func,
  debounceTimeout: PropTypes.number
};
